import { Component, Input, ViewChild } from '@angular/core';
import { BaseModalComponent } from 'projects/libraries/syslink-components/src/lib/modal/base-modal/base-modal.component';
import { StockMoveInternalHeaderStatus } from '../../stock-move-internal-header-statuses/stock-move-internal-header-status.model';
import { SelectComponent } from 'projects/libraries/syslink-components/src/public-api';
import { FilterDescriptor } from 'devextreme/data';
import { StockMoveInternalHeaderStatusesService } from '../../stock-move-internal-header-statuses/stock-move-internal-header-statuses.service';

@Component({
  selector: 'app-stock-move-internal-status-select-modal',
  templateUrl: './stock-move-internal-status-select-modal.component.html',
  styleUrls: ['./stock-move-internal-status-select-modal.component.scss']
})
export class StockMoveInternalStatusSelectModalComponent extends BaseModalComponent<StockMoveInternalHeaderStatus>{
  @Input() public selectFilters: FilterDescriptor | Array<FilterDescriptor>;
  @Input() public expand: FilterDescriptor | Array<FilterDescriptor>;
  @Input() public title: string = "Select internal status";
  @Input() public content?: string;
  @Input() public data: any;
  @ViewChild('select') select?: SelectComponent;

  constructor(public stockMoveInternalHeaderStatusesService: StockMoveInternalHeaderStatusesService) {
    super();
  }

}